<div class="wallets-container" *appHasPermission="[{ resource: Resources.Reports, scope: Scopes.Read }]">
  <div class="wallets-header">
    <div class="title-section">
      <div class="title-container">
        <div class="inner-tab-title">Wallets</div>
        <app-button
          *appHasPermission="{ resource: Resources.Reports, scope: Scopes.Export }"
          buttonVariant="accent"
          buttonType="button"
          [state]="exportButtonState"
          (buttonClick)="openExport()"
        >
          <img src="shared-assets/icons/download.png" alt="Export Icon" class="icon" />
          <span>Export</span>
        </app-button>
      </div>
    </div>
    <div class="filter-buttons">
      <app-button buttonVariant="filter" buttonType="button" [active]="filtersApplied" (buttonClick)="toggleFilters()">
        <img [src]="'shared-assets/icons/filter.png'" alt="Filter Icon" class="filter-icon" />
        <span>Filters</span>
        @if (filtersApplied) {
          <span class="clear-icon" title="Clear filters" (click)="onFilterReset(); $event.stopPropagation()">
            <img src="shared-assets/icons/close.png" alt="Filter Icon" class="clear-icon" />
          </span>
        }
      </app-button>

      <app-date-picker
        [selectedPeriod]="selectedPeriod"
        (rangeChange)="onDateRangeSelected($event)"
        (presetSelected)="onPresetPeriod($event)"
        [isDisabled]="isDisabled"
      />

      <app-pill-search
        [searchText]="searchText"
        placeholder="Search"
        (searchChange)="updateSearch($event)"
        [isDisabled]="isDisabled"
      />
    </div>
  </div>
  <div class="table-container">
    @if (initialLoading || isLoading) {
      <div class="loading-container">
        <app-loading-spinner size="large" label="Loading wallets..."></app-loading-spinner>
      </div>
    } @else if (error) {
      <div class="error-container">
        <p class="error-message">{{ error }}</p>
        <app-button buttonVariant="retry" buttonType="button" (buttonClick)="loadWallets()">Retry</app-button>
      </div>
    } @else {
      <table class="wallets-table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Merchant</th>
            <th>Wallet Address</th>
            <th>Blockchain</th>
            <th>Amount</th>
            <th>
              Amount
              @if (baseCurrencySymbol) {
                <span>({{ baseCurrencySymbol }})</span>
              }
            </th>
            <th>Last Modified</th>
            @if (isSettlementApp) {
              <th>Risk Level</th>
            }
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          @if (hasWallets) {
            @for (wallet of wallets; track $index) {
              <tr class="wallet-row">
                <td>{{ wallet.walletType }}</td>
                <td>{{ wallet.merchantName || 'System' }}</td>
                <td class="olv-address" [matTooltip]="wallet.address">
                  {{ shortenAddress(wallet.address, 6, 4) }}
                </td>
                <td>{{ wallet.blockchain }}</td>
                <td>{{ wallet.currencyAmount | formatCoinCurrency: wallet.currencyDisplayPrecision }}</td>
                <td>{{ wallet.baseCurrencyAmount | formatCoinCurrency: wallet.baseCurrencyDisplayPrecision }}</td>
                <td>{{ wallet.lastModified | date: 'MMM d, hh:mm a' }}</td>
                @if (isSettlementApp) {
                  <td>
                    <app-state-badge type="risk" [value]="wallet.riskLevel"></app-state-badge>
                  </td>
                }
                <td>
                  <span class="status-text" [ngClass]="'status-' + (wallet.status | lowercase)">
                    {{ wallet.status }}
                  </span>
                </td>
              </tr>
            }
          } @else {
            <tr class="empty-row">
              <td colspan="9">
                <app-empty-state
                  [filtersApplied]="filtersApplied"
                  [searchText]="searchText"
                ></app-empty-state>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }

    <app-show-more
      [isShowMore]="hasWallets && hasMoreWallets && !initialLoading"
      [isLoading]="isLoadingMore"
      (loadMore)="loadMoreWallets()"
    />
  </div>
</div>
